export default __webpack_public_path__ + "static/media/404.7a76917a.svg";